import client from 'client';
import { UserData, UserResponse, UserPreview } from '../types';
import { prepareUser } from '../helpers';

type FetchCurrentUser = (eventId: number) => Promise<UserData>;

export const fetchCurrentUserByEventId: FetchCurrentUser = async eventId => {
    const endpoint = `/api/v2/people/events/${eventId}/user/details`;
    const response = await client().post<UserResponse>(endpoint);
    return prepareUser(response.data);
};

type UpdateCurrentUser = (args: {
    eventId: number;
    userProfileId: number;
    payload: Partial<UserData>;
}) => Promise<void>;

// TODO: fix this typo
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
/* @ts-ignore */
export const updateCurrentUser: UpdateCurrentUser = ({ eventId, userProfileId, payload }) => {
    const endpoint = `/api/v2/people/events/${eventId}/user/details/${userProfileId}`;
    return client().put<UserData>(endpoint, payload);
};

type UserProfileIdResponse = {
    userProfileId: number;
};

type FetchUserProfileIdByChatId = (
    eventId: number,
    chatId: string | number | null
) => Promise<number>;

export const fetchProfileIdByChatId: FetchUserProfileIdByChatId = async (eventId, chatId) => {
    const url = `/api/v2/chat/events/${eventId}/chat/users/GET_STREAM/${chatId}`;
    const response = await client().get<UserProfileIdResponse>(url);
    return response.data.userProfileId;
};

type FetchUserByUserProfileId = (
    eventId: number,
    userProfileId: number | string | null
) => Promise<UserPreview>;

// TODO: fix this typo
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
/* @ts-ignore */
export const fetchUserByUserProfileId: FetchUserByUserProfileId = async (
    eventId,
    userProfileId
) => {
    const url = `/api/v2/people/events/${eventId}/user/details/search/${userProfileId}`;
    const response = await client().get<{ data: UserData }>(url);
    return response.data;
};
